import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import ProductCarousel from "src/react/components/product-carousel";
import ProductBasketButton from "src/react/pages/signup/components/product-basket-button";
import ProductCard from "src/react/components/product-card";
import { Container } from "src/react/layout";

function ProductUpsellCarousel({ products = [] }) {
  return (
    <CarouselContainer>
      <ProductCarousel title="Customers also bought" maxWidth={1000}>
        {products.map((product) => (
          <ProductCard key={product.id} product={product} size="small">
            <ProductBasketButton
              data-selector={`Product-button-${product.id}`}
              sku={product.id}
              isProductOutOfStock={product.outOfStock}
              css={buttonStyles}
              size="small"
              showBasketLinkInSuccessToast={true}
            />
          </ProductCard>
        ))}
      </ProductCarousel>
    </CarouselContainer>
  );
}
ProductUpsellCarousel.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object),
};

export default ProductUpsellCarousel;

const CarouselContainer = styled(Container)`
  margin-bottom: 20px;
`;

const buttonStyles = {
  width: "100%",
  maxWidth: "220px",
};
